import { useState, useEffect } from 'react'
import { getEmpsSearchLevelAPI } from '../services/level'

function UseEmpsLavel() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await getEmpsSearchLevelAPI()
      if (!resp) return

      if (resp.status) {
        const newData = resp.result.map((d, i) => {
          return { value: d.levelId, label: d.levelName }
        })
        setData(newData)
      } else {
        setData([])
      }
    }
    getData()
  }, [])

  return data
}

export default UseEmpsLavel
